/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  getErrorDetailsFn,
  getInputFieldProps,
  safeToString,
} from "../../../utils/common";
import useAPIHandler from "../../../hook/use-api-handler";
import { holidayValidationSchema } from "./holiday-validation";
import {
  HOLIDAY_API,
  HOLIDAY_INITIAL_STATE,
  HOLIDAY_INPUT_FIELDS,
} from "./holiday-constant";
import fetchDataWithPromise from "../../../utils/fetch-data";
import useSnackbar from "../../../hook/use-snakbar";

import { useNavigate } from "react-router-dom";

const useHolidayService = () => {
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();
  const [esiInputs, setesiInputs] = useState(
    structuredClone(HOLIDAY_INITIAL_STATE)
  );
  const [holidayListinfo, setholidayListinfo] = useState({});
  const [open, setOpen] = useState(false);
  const [addAnother, setaddAnother] = useState(false);
  const handleClickOpen = () => {
    setesiInputs(structuredClone(HOLIDAY_INITIAL_STATE));
    setOpen(true);
  };
  const handleEditModalOpen = (data) => {
    setesiInputs(data);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [resource, setResource] = useState(null);

  useEffect(() => {
    // Refetch data whenever `page` or `search` changes
    setResource(fetchDataWithPromise(HOLIDAY_API.HOLIDAY_LIST.URL));
 
  }, [page, search]);
const navigate=useNavigate();
  useEffect(() => {
    // Refetch data whenever `page` or `search` changes
 
    fetchData({url:HOLIDAY_API.HOLIDAY_LIST.URL}).then(res=>{

      if(!res?.data || !res?.data?.holidays?.length){

        handleClickOpen()
      }
      if(!res?.data?.holidays?.length){
        navigate("/holiday-management")
      }
    })
  }, []);

  const { fetchData } = useAPIHandler();
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChangeFunction = (e, name) => {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      HOLIDAY_INPUT_FIELDS[name].customOptions &&
      HOLIDAY_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = HOLIDAY_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        esiInputs
      );
    }

    setesiInputs((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = holidayValidationSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      //   context: { allowanceType: allowance.allowanceType },
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  };

  const handleSubmitFn = async () => {
  

    const { holidayDate, holidayName } = esiInputs;

   let payload = {
      data: {
        holidayDate,
        holidayName,
      },
   ...HOLIDAY_API.HOLIDAY_CREATE
    };

    if(esiInputs?.holidayId){
      payload= {
        data: {
          holidayDate,
          holidayName,
          holidayId:esiInputs?.holidayId
        },
        ...HOLIDAY_API.HOLIDAY_UPDATE,
        url:HOLIDAY_API.HOLIDAY_UPDATE.url +esiInputs?.holidayId
      };
    }

    const { error } = holidayValidationSchema.validate(
      {
        holidayDate,
        holidayName,
      },
      {
        abortEarly: false,
      }
    );

    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      setCreateUpdateLoading(true);

      try {
        await fetchData(payload);

        openSnackbar({
          message:  `Holiday ${esiInputs?.holidayId ? "Update": "Added"} succesfully!`,
          color: "success",
        });

        setResource(fetchDataWithPromise(HOLIDAY_API.HOLIDAY_LIST.URL));
        if (addAnother) {
          setesiInputs(structuredClone(HOLIDAY_INITIAL_STATE));
        } else {
          setOpen(false);
        }
      } catch (error) {
        setCreateUpdateLoading(false);

        const { message, errorObj } = getErrorDetailsFn(error);

        openSnackbar({
          message,
          color: "danger",
        });
        setErrors(errorObj);
      } finally {
        setCreateUpdateLoading(false);
      }
    }
  };

  function handleDisableAllESIFn() {
    if (!esiInputs.isDisableEsi) {
      setErrors({});
      setesiInputs({
        ...structuredClone(HOLIDAY_INITIAL_STATE),
        isDisableEsi: true,
      });
    } else {
      setesiInputs((prev) => ({ ...prev, isDisableEsi: false }));
    }
  }

  const [stateList, setStateList] = useState([]);
  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      HOLIDAY_INPUT_FIELDS[fieldName] || {};

    let disabled = !!restProps.disabled;
    if (esiInputs.isDisableEsi === true) {
      disabled = true;
    }

    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: esiInputs,
        type: restProps.type || "text",
        error,
        handleChangeFunction,
      }),
      disabled,
    };

    return props;
  };

  // useEffect(() => {

  //   const URL = HOLIDAY_API.HOLIDAY_LIST.URL;
  //   const METHOD = HOLIDAY_API.HOLIDAY_LIST.METHOD;
  //   const payload={
  //     url:URL,
  //     METHOD
  //   }
  //   fetchData(payload).then(
  //     (res) => {

  //       setholidayListinfo(res?.data||{});
  //       }
  //   );

  // }, []);

  function hanldeAddAnotherFn() {
    setaddAnother((prev) => !prev);
  }

  return {
    esiInputs,
    setesiInputs,
    getInputFieldPropsFn,
    handleDisableAllESIFn,
    handleSubmitFn,
    createUpdateLoading,
    stateList,
    open,
    setOpen,
    handleClickOpen,
    handleClose,
    addAnother,
    setaddAnother,
    hanldeAddAnotherFn,
    holidayListinfo,
    resource,
    setResource,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    handleEditModalOpen
  };
};

export default useHolidayService;
